import { Conv1BaseValueConverter } from 'General/Resources/ValueConverters/Conv1Base';

export class Conv1ValueConverter extends Conv1BaseValueConverter {
}